import React from 'react';

import { Skeleton } from '@material-ui/lab';

import { AlertSkeletonProps } from './AlertSkeleton.types';

const AlertSkeleton: React.FC<AlertSkeletonProps> = ({
  className,
}) => {
  return (
<div className={`flex flex-center flex-justify default-border-radius box-shadow alert-with-icon-container p4 primary ${className}`}>
      <div className="flex flex-center">
        <Skeleton width={20} height={20} variant="circle" className="mt3"/>
        <div className="flex flex-column ml2">
          <Skeleton width={150} height={25} className='mb1' />
          <Skeleton width={250} height={15} />
        </div>
      </div>
    </div>
  );
};

export default AlertSkeleton;
export { AlertSkeletonProps };
